import {
  CommonCodeGroupType,
  useGetCommonCodeGroupsByTypeAsAdminQuery,
} from "../../../lib/apollo/graphql/generated";
import SelectBox from "../../common/components/SelectBox";

interface VideoCategorySelectBoxProps {
  value: string;
  onSelect: (categoryId: string) => void;
}

export default function VideoCategorySelectBox({
  value,
  onSelect,
}: VideoCategorySelectBoxProps) {
  const { data } = useGetCommonCodeGroupsByTypeAsAdminQuery({
    variables: {
      types: [CommonCodeGroupType.VideoContentCategory],
    },
  });

  const status = data?.getCommonCodeGroupsByTypeAsAdmin?.filter(
    (item) => item.groupCode === CommonCodeGroupType.VideoContentCategory
  )[0];

  const options =
    status?.activeCommonCodes.map((code) => ({
      label: code.name,
      value: code.id,
    })) || [];

  return (
    <SelectBox
      label="카테고리"
      value={value}
      options={options}
      onSelect={onSelect}
      className="h-[50px]"
    />
  );
}
